import { useEffect, useState } from 'react';
import { fetchIncidents, type Incident } from '../lib/api';

function fmtDuration(s: number | null | undefined): string {
  if (s == null) return 'ongoing';
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${Math.round(s / 60)}m`;
  if (s < 86400) return `${(s / 3600).toFixed(1)}h`;
  return `${(s / 86400).toFixed(1)}d`;
}

export default function IncidentLog() {
  const [items, setItems] = useState<Incident[] | null>(null);
  useEffect(() => {
    let alive = true;
    fetchIncidents(20).then((i) => { if (alive) setItems(i); }).catch(() => { if (alive) setItems([]); });
    return () => { alive = false; };
  }, []);

  if (!items) return null;
  if (items.length === 0) {
    return (
      <section className="mt-14">
        <h2 className="display text-2xl md:text-3xl text-offwhite mb-4 px-1 tracking-wide">Recent incidents</h2>
        <div className="card text-sm text-offwhite/70">No incidents in the recorded window. Smooth flight so far.</div>
      </section>
    );
  }

  return (
    <section className="mt-14">
      <h2 className="display text-2xl md:text-3xl text-offwhite mb-4 px-1 tracking-wide">Recent incidents</h2>
      <div className="grid gap-3">
        {items.map((i) => (
          <div key={i.id} className="card">
            <div className="flex items-start justify-between gap-3 flex-wrap">
              <div>
                <p className="text-sm font-semibold text-offwhite">
                  {i.service_name}
                  <span className="text-offwhite/40 text-xs ml-2 font-normal">{i.group_name}</span>
                </p>
                <p className="text-xs text-offwhite/55 mt-1">
                  {new Date(i.started_at).toLocaleString()}
                  {i.resolved_at ? `, resolved ${new Date(i.resolved_at).toLocaleString()}` : ''}
                </p>
                {i.note ? <p className="text-sm text-offwhite/80 mt-2">{i.note}</p> : null}
              </div>
              <div className="text-right">
                <span className={i.kind === 'down' ? 'pill-red' : 'pill-yellow'}>{i.kind}</span>
                <p className="text-xs text-offwhite/55 mt-1.5">{fmtDuration(i.duration_s ?? null)}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
